var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"multiple":_vm.multiple,"chips":_vm.multiple,"clearable":"","deletable-chips":_vm.multiple,"label":_vm.label,"items":_vm.items,"value":_vm.value},on:{"change":function (v) { return _vm.$emit('input', v); }}})}
var staticRenderFns = []

export { render, staticRenderFns }